import * as Actions from "./actions";
import initialState from "../store/initialState";

export const ReadSizeReducer = (
    state = initialState.readSize,
    action
) => {
    switch (action.type) {
        case Actions.READ_SIZE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
